// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__2Xjjo","options":"AnswerScale_options__2uJ-r","selected":"AnswerScale_selected___kvvc"};